import css from './RulesModal.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function RulesModal({ callback }: any) {
    const { useLang, useState, useEffect, useRouter, Link, gtm } = useGlobal();
    const { t } = useLang('RV');
    const { locale } = useRouter();

    return (
        <dialog className={`rules-modal ${css['rules-modal']}`}>
            <div className="modal-content">
                <div className="modal-header">
                    <span className="header-title">{t('N_rules')}:</span>
                    <svg className="close" onClick={callback} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M6 5L19 18M19 5L6 18" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </div>
                <ul className="modal-body">
                    {[1, 2, 3, 4, 5]?.map((item: any, k: number) => (
                        <li className="text" key={k}>
                            {t(`N_rule${item}`)}
                        </li>
                    ))}
                </ul>
            </div>
        </dialog>
    );
}
